require("!!/home/runner/work/Core/Core/web/reviewportal/node_modules/script-loader/addScript.js")(require("!!/home/runner/work/Core/Core/web/reviewportal/node_modules/raw-loader/index.js!/home/runner/work/Core/Core/web/reviewportal/node_modules/moment/min/moment.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/moment/min/moment.min.js
// module id = 585
// module chunks = 2